import { supabase } from "@/integrations/supabase/client";

/**
 * Lightweight feature usage tracker. Fires and forgets, never blocks UI.
 * 
 * @param feature - Feature name, e.g. 'vocabulary', 'grammar', 'growth'
 * @param action  - Action type, e.g. 'view', 'click', 'start_practice'
 * @param metadata - Optional extra context
 */
export function trackFeatureUsage(
  feature: string,
  action: string = 'view',
  metadata?: Record<string, unknown>
) {
  // Fire-and-forget, async but not awaited
  (async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      // Exclude test account (Phil Person)
      if (user.id === 'f824613e-efb7-4410-a916-89061071e75b') return;

      await supabase.from('feature_usage' as any).insert({
        user_id: user.id,
        feature,
        action,
        metadata: metadata ?? {},
      } as any);
    } catch {
      // Silent, tracking must never disrupt the app
    }
  })();
}
